import { render, staticRenderFns } from "./EditSub.vue?vue&type=template&id=d8cf7438&"
import script from "./EditSub.vue?vue&type=script&lang=js&"
export * from "./EditSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BFormInput, BCol, BFormText, BButton, BRow, BCard, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BFormInput, BCol, BFormText, BButton, BRow, BCard, BForm, BContainer})
    

export default component.exports